var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormContent',{attrs:{"type":"page","newOption":_vm.newOption}})
}
var staticRenderFns = []

export { render, staticRenderFns }